import { jsx as _jsx } from "react/jsx-runtime";
import { LL_V_L, TS_Tabs } from '@nu-art/thunderstorm-frontend/index';
import './Panel_ExpressionSidePanel.scss';
import { Component_ExpressionDescription } from './expression-description/Component_ExpressionDescription.js';
import { Component_JSONPreview } from './expression-json-preview/Component_JSONPreview.js';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import { Component_PyJsonPreview } from './py-json-preview/Component_PyJsonPreview.js';
import { ModuleFE_Expression, ModuleFE_Value, ModuleFE_Variable } from '../../../../../../_entity.js';
import { Component_PrettyPrint_Expression } from '../../../../../_components/expression-pretty-print/Component_PrettyPrint_Expression/Component_PrettyPrint_Expression.js';
export const UtilsTab_ExpressionDescription = 'Description';
export const UtilsTab_CalculationSimulator = 'Simulation';
export const UtilsTab_JsonPreview = 'JSON';
export const UtilsTab_PrettyPrintV2 = 'Pretty Print V2';
export const UtilsTab_PyJsonPreview = 'PY-JSON';
export class Panel_ExpressionSidePanel extends TS_EditableItemComponentProto {
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (!nextProps.editable)
            return true;
        return super.shouldComponentUpdate(nextProps, nextState, nextContext);
    }
    shouldReDeriveState(nextProps) {
        if (!nextProps.editable)
            return true;
        return super.shouldReDeriveState(nextProps);
    }
    deriveStateFromProps(nextProps, state) {
        state = nextProps.editable ? super.deriveStateFromProps(nextProps, state) : { ...this.state };
        state.selectedTab ??= this.state?.selectedTab ?? nextProps.defaultTab ?? UtilsTab_ExpressionDescription;
        return state;
    }
    render() {
        const tabs = [
            ...(this.props.additionalTabs ?? []),
            {
                uid: UtilsTab_ExpressionDescription,
                disabled: !this.state.editable,
                content: () => _jsx(Component_ExpressionDescription, { editable: this.state.editable }),
                title: UtilsTab_ExpressionDescription,
            },
            {
                uid: UtilsTab_JsonPreview,
                title: UtilsTab_JsonPreview,
                disabled: !this.state.editable,
                content: () => _jsx(Component_JSONPreview, { editable: this.state.editable }),
            },
            {
                uid: UtilsTab_PyJsonPreview,
                title: UtilsTab_PyJsonPreview,
                disabled: !this.state.editable,
                content: () => _jsx(Component_PyJsonPreview, { editable: this.state.editable })
            },
            {
                uid: UtilsTab_PrettyPrintV2,
                title: UtilsTab_PrettyPrintV2,
                disabled: !this.state.editable,
                content: () => _jsx(Component_PrettyPrint_Expression, { expression: this.state.editable.item, interactive: false, guidelines: true, modules: {
                        variable: ModuleFE_Variable,
                        value: ModuleFE_Value,
                        expression: ModuleFE_Expression,
                    } })
            }
        ];
        return _jsx(LL_V_L, { className: 'utils-panel', children: _jsx(TS_Tabs, { selectedTabId: this.state.selectedTab, onSelected: (selectedTabId) => this.setState({ selectedTab: selectedTabId }), tabs: tabs }) });
    }
}
//# sourceMappingURL=Panel_ExpressionSidePanel.js.map